import { DateTime } from 'luxon';

export const computeEstimatedDeliveryDate = (
  averageDeliveryDate: string,
  estimatedTransitTime: number | null,
): string => {
  const defaultRSETransitTime = 2;
  if (
    estimatedTransitTime === null ||
    estimatedTransitTime === undefined ||
    !Number.isInteger(estimatedTransitTime)
  ) {
    return averageDeliveryDate;
  }

  const dateTimeObj = DateTime.fromISO(averageDeliveryDate, { zone: 'utc' });
  const adjustedDeliveryDate = dateTimeObj.plus({
    days: estimatedTransitTime - defaultRSETransitTime,
  });

  return adjustedDeliveryDate.toISODate() as string;
};
